module.exports = __webpack_public_path__ + "gg.svg?49214809e2a8b472548bc9cc08d5d97d";